<script>
import moment from "moment";
import { mapGetters } from "vuex";
import ComplianceForm from "./ComplianceForm";

export default {
  name: "UpdateActionForm",
  components: { ComplianceForm },
  data() {
    return {
      data: null,
      complinaces: [],
      complinaceItems: null,
      complianceUserDetails: null,
      showAgreement: true,
    };
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("compliance", ["getComplianceUserDetails"]),
  },
  beforeMount() {
    console.log(
      "getComplianceUserDetails",
      this.getComplianceUserDetails,
      this.getModalInfo
    );

    // if (this.getModalInfo != "expected") {
    //   const convertComplinaces = JSON.parse(JSON.stringify(this.getModalInfo));
    //   this.complinaces =
    //     convertComplinaces.length > 0
    //       ? convertComplinaces.map((complinance) => {
    //           let pivot = complinance.pivot ? JSON.parse(complinance.pivot.metadata) : "";
    //           return {
    //             name: complinance.name,
    //             id: complinance.id,
    //             type: complinance.type,
    //             answer: complinance.form_metadata ? complinance.form_metadata : "",
    //             pivot: pivot,
    //           };
    //         })
    //       : [];
    // }
  },
  watch: {
    getComplianceUserDetails(data) {
      this.complianceUserDetails = JSON.parse(JSON.stringify(data));
    
      if (this.complianceUserDetails?.compliances && this.complianceUserDetails?.compliances?.questionnaires) {       
        for (const [questionnaireKey, questions] of Object.entries(this.complianceUserDetails.compliances.questionnaires)) {
          const questionnaire = this.complianceUserDetails.compliances.questionnaires[questionnaireKey];
          const firstQuestionKey = Object.keys(questionnaire)[0];
          const firstQuestionAnswers = questionnaire[firstQuestionKey];
          this.complianceUserDetails.compliances.questionnaires[questionnaireKey].notesAnswers =
          this.removeDuplicateNotes(firstQuestionAnswers);

          for (const [questionText, answers] of Object.entries(questions)) {
            if (questionText !== "notesAnswers") {
              const cleanedAnswers = this.removeDuplicateAnswers(answers);
              this.complianceUserDetails.compliances.questionnaires[questionnaireKey][questionText] = cleanedAnswers;
            }
          }
        }
        this.setQuestionnaire();
      }

      if (this.complianceUserDetails?.compliances && this.complianceUserDetails?.compliances?.agreements) {
        this.showAgreement = true;
        for (const [agreementKey, questions] of Object.entries(this.complianceUserDetails.compliances.agreements)) {
          const agreement = this.complianceUserDetails.compliances.agreements[agreementKey];
          const firstQuestionKey = Object.keys(agreement)[0];
          const firstQuestionAnswers = agreement[firstQuestionKey];
          this.complianceUserDetails.compliances.agreements[agreementKey].notesAnswers =
          this.removeDuplicateNotes(firstQuestionAnswers);
          for (const [questionText, answers] of Object.entries(questions)) {
            if (questionText !== "notesAnswers") {
              const cleanedAnswers = this.removeDuplicateAnswers(answers);
              this.complianceUserDetails.compliances.agreements[agreementKey][questionText] = cleanedAnswers;
            }
          }
        }
        this.setAgreement();
      }
    }
  },
  methods: {
    openPDF(link) {
      window.open(link, "_blank");
    },
    getPDFName(link) {
      const fileNameWithExt = link.substring(link.lastIndexOf("/") + 1);
      const fileName = fileNameWithExt.replace(".pdf", "");
      return fileName;
    },
    removeDuplicateAnswers(answers) {
      const reversed = [...answers].reverse(); // reverse to oldest → newest
      let seen = [];
    
      let lastAnswerText = null;
      for (const item of reversed) {
        // console.log('item', item);
        const currentAnswer = item.metadata?.answer?.text?.trim().toLowerCase();

        if (currentAnswer !== lastAnswerText) {
          seen.push(item);
          lastAnswerText = currentAnswer;
        }
      }
      seen = [...seen].reverse(); 
      return seen;
    },
    removeDuplicateNotes(answers) {
      const reversed = [...answers].reverse(); // iterate from oldest to newest
      const seen = [];

      let lastNoteText = null;

      for (const item of reversed) {
        const currentNote = item.metadata?.notes?.trim();

        if (currentNote) {
          if (currentNote !== lastNoteText) {
            seen.push(item);
            lastNoteText = currentNote;
          }
          // else: skip duplicate note
        } else {
          // Note is empty and lastNoteText was not empty
          if (lastNoteText) {
            item.metadata.isNotesEmpty = true; // mark it
            seen.push(item);
            lastNoteText = null; // reset to handle further new notes
          }
          // else: consecutive empty notes or already empty — skip
        }
      }

      return seen.reverse(); // return in original order
    },
    setAgreement() {
      this.showAgreement = true;
      this.complinaceItems = this.complianceUserDetails.compliances.agreements;
    },
    setQuestionnaire() {
      this.showAgreement = false;
      this.complinaceItems = this.complianceUserDetails.compliances.questionnaires;
    },
    getDate(date) {
      if (this.getLanguage === "ar")
        return moment
          .utc(date)
          .tz(moment.tz.guess())
          .locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm") + 
          (moment.utc(date).tz(moment.tz.guess()).format("A") === "AM" ? " ص" : " م");

      return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format("DD/MM/YYYY - h:mm A");
    },

    getDay(date) {
      return moment.utc(date).tz(moment.tz.guess()).format("DD/MM/YYYY");
    },
  },
};
</script>

<template>
  <div class="site-details-wrapper" style="width: 416px">
    <div class="modal-toptitle">
      <p class="modal-title">{{ $t('common.complianceDetails')}}</p>

      <svg
        class="close-btn-svg"
        @click="$bvModal.hide('dashboardCompliances')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <template v-if="complinaces.length > 0">
      <div v-for="(el, i) in complinaces" :key="'el' + i">
        <ComplianceForm :element="el" :index="i" />
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <button
          class="btn btn-primary px-3"
          @click="$bvModal.hide('dashboardCompliances')"
        >
          {{ $t('common.close') }}
        </button>
      </div>
    </template>

    <div class="d-flex" style="gap: 12px; margin-bottom: 32px">
    <button class="agreement-btn" type="button" v-if="complianceUserDetails &&
        complianceUserDetails.compliances &&
        complianceUserDetails.compliances.agreements
      " @click="setAgreement" :style="showAgreement ? 'background: #103F5E; color: #fff' : 'background-color: #E5E5E5; color: #4A4A4A'">{{$t('common.agreement')}}</button>

    <button class="quest-btn" type="button" v-if="complianceUserDetails &&
        complianceUserDetails.compliances &&
        complianceUserDetails.compliances.questionnaires
      " @click="setQuestionnaire" :style="!showAgreement ? 'background: #103F5E; color: #fff' : 'background-color: #E5E5E5; color: #4A4A4A'">{{$t('common.questionnaire')}}</button>
    </div>

    <template v-if="complinaceItems">
      <div
        class="questions-custom"
        v-for="(questions, type, i) in complinaceItems"
        :key="'q' + i"
      >
        <div class="grayagreement-con">
          <h2 class="agree-question">{{ type }}</h2>
        </div>
        <div
          class="questions2-custom"
          v-for="(compliances, question, index) in questions"
          :key="'c' + index"
        >
          <template v-if="question != 'notesAnswers'">
          <template v-if="showAgreement && compliances[0].form_metadata.questions[0].content_type == 'IMAGE'">
            <div class="img-agr">
              <img v-viewer :src="compliances[0].form_metadata.questions[0].attachment_url" class="cursor-zoomin thumbnail-image" />
            </div>
          </template>

          <template v-else-if="showAgreement && compliances[0].form_metadata.questions[0].content_type == 'PDF'">
            <div class="pdf-agr">
              <div class="d-flex align-items-center justify-content-between" style="padding: 20px 20px 0 24px;">
                <span class="d-flex align-items-center justify-content-center cursor-pointer" @click="openPDF(compliances[0].form_metadata.questions[0].attachment_url)">{{ getPDFName(compliances[0].form_metadata.questions[0].attachment_url) }}</span>
                <svg class="cursor-pointer" @click="openPDF(compliances[0].form_metadata.questions[0].attachment_url)" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0864 0C14.5903 4.31018e-08 14.9987 0.415294 14.9987 0.927585L14.9987 4.86299C14.9987 5.37528 14.5903 5.79058 14.0864 5.79058C13.5826 5.79058 13.1741 5.37528 13.1741 4.86299V3.16697L9.89333 6.50274C9.53706 6.86499 8.95942 6.86499 8.60314 6.50274C8.24687 6.1405 8.24687 5.55319 8.60314 5.19094L11.884 1.85517L10.2159 1.85517C9.71203 1.85517 9.30358 1.43988 9.30358 0.927584C9.30358 0.415294 9.71203 4.91633e-08 10.2159 6.22367e-09L14.0864 0Z" fill="#103F5E"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.77216C0 2.08096 1.3484 0.709961 3.01174 0.709961H6.52544C7.07989 0.709961 7.52936 1.16696 7.52936 1.73069C7.52936 2.29443 7.07989 2.75143 6.52544 2.75143H3.01174C2.4573 2.75143 2.00783 3.20843 2.00783 3.77216V11.938C2.00783 12.5018 2.4573 12.9588 3.01174 12.9588H11.0431C11.5975 12.9588 12.047 12.5018 12.047 11.938V8.36546C12.047 7.80173 12.4964 7.34473 13.0509 7.34473C13.6053 7.34473 14.0548 7.80173 14.0548 8.36546V11.938C14.0548 13.6292 12.7064 15.0002 11.0431 15.0002H3.01174C1.3484 15.0002 0 13.6292 0 11.938V3.77216Z" fill="#103F5E"/>
                </svg>
              </div>
              <hr style="border-top: 1px solid #C8C0C0; margin: 20px 0 0 0;">
              <iframe 
              class="iframe-container"
                :src="compliances[0].form_metadata.questions[0].attachment_url + '#toolbar=0&navpanes=0&scrollbar=0'"
                width="100%" 
                height="483px" 
                style="border:none;">
              </iframe>
            </div>
          </template>
        
          <p v-else class="txt-body">{{ showAgreement ? "" : (index + 1 + "-") }} {{ question }}</p>
          <div
            class="alltxt-customization"
            v-for="(compliance, index1) in compliances"
            :key="'compliance' + index1"
          >
          <div :class="{
                'green-pill': JSON.parse(compliance.metadata.answer.desired),
                'red-pill': !JSON.parse(compliance.metadata.answer.desired),
              }">
          <p
              :class="{
                'text-green': JSON.parse(compliance.metadata.answer.desired),
                'text-red': !JSON.parse(compliance.metadata.answer.desired),
              }"
            >
              {{ compliance.metadata.answer.text }}
            </p>
          </div>
            
            <div class="graytxt-con">
              <span class="first-gray">{{
                getDate(compliance.created_at)
              }}<b> &nbsp;<b>•</b>&nbsp; </b>({{
                  $t(`common.${compliance.metadata.actionBy.toLowerCase()}`) +
                  (compliance.metadata.actionBy == "Admin"
                    ? " - " + compliance.full_name_action_by
                    : "")
                }})
              </span>
            </div>
            <hr class="addcustom-line"
              v-if="(Object.keys(questions).filter((q) => q !== 'notesAnswers').length > 1 && index !== Object.keys(questions).length - 1) || (index == Object.keys(questions).filter((q) => q !== 'notesAnswers').length - 1 && questions.notesAnswers && questions.notesAnswers.length > 0)"
            />

          </div>
        </template>
        </div>

        <!-- Notes here -->
          <div v-if="questions.notesAnswers && questions.notesAnswers.length > 0">
            <h4 class="notes-header">{{ $t('common.notes.complianceNotes')}}</h4>
            <div
              v-for="(compliance, index2) in questions.notesAnswers"
              :key="'notes' + index2"
            >
              <div v-if="compliance.metadata.notes || compliance.metadata.isNotesEmpty">
              <div v-if="compliance.metadata.isNotesEmpty" class="notes-empty">
                {{ $t('common.notes.notesRemoved') }}
              </div>
                <p v-else class="notes-graycon notes-txt">{{ compliance.metadata.notes }}</p>
                <span class="notes-date">{{
                  getDate(compliance.created_at)
                }}<b> &nbsp;<b>•</b>&nbsp; </b>({{
                    $t(`common.${compliance.metadata.actionBy.toLowerCase()}`) +
                    (compliance.metadata.actionBy == "Admin"
                      ? " - " + compliance.full_name_action_by
                      : "")
                  }})
                </span>
              </div>
            </div>
          </div>

          <hr
            class="addcustom-line-thick"
            v-if="Object.keys(complinaceItems).length > 1 && i !== Object.keys(complinaceItems).length - 1"
          />

      </div>
    </template>

    <template v-if="complianceUserDetails && complianceUserDetails.documents">
      <div class="grayagreement-con">
        <h2 class="agree-question">{{ $t('common.documentVaccinePcr') }}</h2>
      </div>
      <div
        v-for="(document, i) in complianceUserDetails.documents"
        :key="'doc' + i"
      >
        <h2 class="vaccine-data">
          {{ document.name }}
        </h2>

        <div
          class="gray-Pcrcontainer"
          v-if="document.user_documents_type != 'covid_vaccine'"
        >
          <div class="sub-graypcr-container">
            <div
              class="col-lg-6"
              :class="{
                'vp-border-right-grey-4-1': JSON.parse(
                  document.user_documents_metadata
                ).fileAttach,
              }"
            >
              <div class="pcr-result">{{ $t('signInOut.pcrResult')}}</div>
              <div class="pcr-result-subtitle">
                {{
                  JSON.parse(document.user_documents_metadata).certificateModel
                    .tests[0].testResult == "Detected"
                    ? "Positive"
                    : "Negative"
                }}
              </div>
              <div class="pcr-date">{{$t('common.pcrDate')}}</div>
              <div class="pcr-date-subtitle">
                {{
                  getDay(
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.tests[0].dateTimeOfTestResult
                  )
                }}
              </div>
            </div>
            <div
              v-if="JSON.parse(document.user_documents_metadata).fileAttach"
              class="col-lg-6 image-size"
              style="
                display: flex;
                justify-content: flex-end;
                padding-inline-end: 0px;
              "
            >
              <div
                v-viewer
                class="right-pcr-image"
                style="width: 127px; height: 97px"
              >
                <img
                  style="cursor: pointer; width: 100%; height: 100%"
                  class="img-bg"
                  :src="JSON.parse(document.user_documents_metadata).fileAttach"
                />
              </div>
            </div>
          </div>

          <div
            class="notes-graycon"
            v-if="document.metadata && document.metadata.notes"
          >
            <hr class="addcustom-line" />
            <h4 class="vaccine-notes-header">{{ $t('common.notes.notes') }}</h4>
            <p class="vaccine-notes-txt">
              {{ document.metadata.notes }}
            </p>
          </div>
        </div>

        <div
          class="gray-vaccinecontainer"
          v-if="document.user_documents_type == 'covid_vaccine'"
        >
          <div class="sub-graycontainer">
            <div class="row-one vaccine-name">
              <p class="vaccine-protocol">{{ $t('common.doc.vaccineProtocol') }}</p>
              <p class="vaccine-protocol-subtitle">
                {{ JSON.parse(document.user_documents_metadata).protocol }}
              </p>
              <hr class="addcustom-line" style="margin-bottom: 0px" />
            </div>
            <div
              class="columns-container d-flex justify-content-center"
              :class="{
                'justify-content-between': JSON.parse(
                  document.user_documents_metadata
                ).fileAttach,
              }"
            >
              <div class="vp-border-right-grey-4-1">
                <div class="Vaccine-Name">{{ $t('common.doc.vaccineName')}}</div>
                <div class="Vaccine-result">
                  {{
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.vaccinations[0].vaccine
                  }}
                </div>
                <div class="Vaccine-Date">{{$t('common.vaccineDate')}}</div>
                <div class="Vaccine-Date-result">
                  {{
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.vaccinations[0].dateOfVaccination
                  }}
                </div>
              </div>

              <div
                :class="{
                  'vp-ml-25': !JSON.parse(document.user_documents_metadata)
                    .fileAttach,
                  'vp-border-right-grey-4-1': JSON.parse(
                    document.user_documents_metadata
                  ).fileAttach,
                }"
              >
                <template
                  v-if="
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.vaccinations[0].batchNumber
                  "
                >
                  <div class="Batch-Number">{{ $t('common.doc.batchNumber')}}</div>
                  <div class="Batch-Number-result">
                    {{
                      JSON.parse(document.user_documents_metadata)
                        .certificateModel.vaccinations[0].batchNumber
                    }}
                  </div>
                </template>
                <div class="Vaccine-Expiry">{{ $t('common.Vaccine Expiry') }}</div>
                <div class="Vaccine-Expiry-result">
                  {{
                    getDay(
                      JSON.parse(document.user_documents_metadata)
                        .greenCertificatData.expirationTime
                    )
                  }}
                </div>
              </div>

              <div
                v-if="JSON.parse(document.user_documents_metadata).fileAttach"
                style="
                  display: flex;
                  justify-content: flex-end;
                  padding-inline-end: 0px;
                "
              >
                <div
                  v-viewer
                  class="images dash-img clearfix"
                  style="width: 127px; height: 97px"
                >
                  <img
                    style="
                      cursor: pointer;
                      width: 100%;
                      height: 100% !important;
                    "
                    class="img-bg"
                    :src="
                      JSON.parse(document.user_documents_metadata).fileAttach
                    "
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="notes-graycon"
            v-if="document.metadata && document.metadata.notes"
          >
            <hr class="addcustom-line" />
            <h4 class="vaccine-notes-header">{{ $t('common.notes.notes')}}</h4>
            <p class="vaccine-notes-txt">
              {{ document.metadata.notes }}
            </p>
          </div>
        </div>

        <span class="seprated-vaccinetime"
          >{{ getDate(document.updated_at) }}
        </span>
        <span class="seprated-vaccineby"
          >({{ document.metadata.actionBy ? document.metadata.actionBy : "User"
          }}{{
            document.metadata.actionBy
              ? " - " + document.full_name_action_by
              : ""
          }})</span
        >
      </div>
    </template>
  </div>
</template>
<style lang="scss">
div#dashboardCompliances {
  div#dashboardCompliances___BV_modal_content_ {
    div#dashboardCompliances___BV_modal_body_ {
      padding: 40px 42px !important;
      overflow-x: hidden;
      .cursor-zoomin {
        cursor: zoom-in;
        // height: 100%;
        width: 100%;
      }
      .img-agr {
          // border: 2px solid #F2F2F2;
          // border-radius: 8px;
          // padding: 12px;
          height: auto;
          width: 416px;
          margin-bottom: 16px;
      }
      .iframe-container {
        height: 425px !important;
        /* padding: 0 20px 46px 20px; */
        padding-bottom: 0px;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      .pdf-agr {
        height: 483px !important;
        // padding: 20px;
        border: 1px solid #000000;
        border-radius: 12px;
        margin-bottom: 16px;
        span {
          height: 12px;
          font-weight: 600;
          font-size: 16px;
          // align-items: center;
          letter-spacing: 0.25px;
          color: #000000;
        }
      }
      .close-btn-svg{
        position: absolute;
        inset-inline-end: 32px;
        top: 32px;
        cursor: pointer;
      }
      .close-btn-svg:lang(ar){
        margin-inline-start: 33px;
        float: unset;   
      }
      p.modal-title {
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        text-align: center;

        color: #000000;
      }

      .modal-toptitle {
        width: 100%;
        margin-bottom: 40px;
      }
      .modal-closeing {
        margin-inline-end: 33px;
        cursor: pointer;
      }
      .grayagreement-con {
        background: #F2F2F2;
        height: 28px;
        display: flex;
        border-radius: 4px;
        margin-bottom: 24px;
        h2.agree-question {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #4A4A4A;
          margin-top: 5px;
          margin-bottom: 5px;
          margin-inline-end: auto;
          margin-inline-start: 12px;
        }
      }
      //////////////////////

      .questions-custom {
        .questions2-custom {
          p.txt-body {
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #4A4A4A;
            margin-bottom: 16px;
            word-wrap: break-word !important;
          }
        }

        .alltxt-customization {
          .green-pill {
            background: rgba(52, 195, 143, 10%);
            border-radius: 14px;
            padding: 8px 12px;
            width: fit-content;
            margin-bottom: 16px;
          }
          .red-pill {
            background: rgba(244, 106, 106, 10%);
            border-radius: 14px;
            padding: 8px 12px;
            width: fit-content;
            margin-bottom: 16px;
          }
          p.text-green {
            font-weight: 700 !important;
            font-size: 16px !important;
            color: #34C38F !important;
            display: flex;
            align-items: center;
            height: 12px;
          }
          p.text-red {
            font-weight: 700 !important;
            font-size: 16px !important;
            color: #f46a6a !important;
            display: flex;
            align-items: center;
            height: 12px;
          }
          .graytxt-con {
            span.first-gray {
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              color: #787878;
            }
          }
        }
      }
      h2.vaccine-data {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        margin-top: 10px;
        margin-bottom: 9px;
        margin-inline-start: 35px;
        color: #939393;
      }
      .gray-vaccinecontainer {
        background: #f7f7f7;
        border-radius: 10px;
        margin-inline-end: 23px;
        margin-inline-start: 23px;
        margin-bottom: 8px;
        .sub-graycontainer {
          margin: 0px 24px 0px 24px;
        }
      }
      .pcr-block {
        width: 206px;
      }
      span.seprated-vaccinetime {
        margin-inline-start: 47px;
        padding-bottom: 35px;

        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #c7c7c7;
        margin-inline-end: 15px;
      }
      span.seprated-vaccineby {
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #c7c7c7;
      }
      .notes-graycon {
        background: #F2F2F2;
        border-radius: 10px;
        margin-bottom: 16px;
        padding: 8px 12px;
        margin-top: 24px;
      }
      .addcustom-line {
        margin: 24px 0;
        border-top: 1px solid #ebebeb;
      }
      .addcustom-line-thick {
        margin: 32px 0;
        border-top: 5px solid #ebebeb;
        //  height: 1px;
      }
      h4.notes-header {
        font-weight: 600;
        font-size: 16px;
        line-height: 17px;
        color: #4A4A4A;
        margin: 0;
      }
      p.notes-txt {
        font-weight: 400;
        font-size: 16px;
        word-break: break-word;
        line-height: 24px;
        color: #4A4A4A;
      }
      span.notes-date {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #787878;
      }
      .notes-empty {
        background: rgba(244, 106, 106, 10%);
        color: #F46A6A;
        padding: 8px 12px;
        width: fit-content;
        border-radius: 14px;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        height: 28px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 24px;
        margin-bottom: 16px;
      }
      .agreement-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px;
        gap: 10px;
        width: 84px;
        height: 26px;
        border-radius: 13.5px;
        font-size: 14px;
      }
      .quest-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px;
        gap: 10px;
        width: 104px;
        height: 26px;
        border-radius: 13.5px;
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.gray-Pcrcontainer {
  background: #f7f7f7;
  border-radius: 10px;
  margin: auto;
  width: 437px;
  margin-bottom: 20px;
  .sub-graypcr-container {
    padding: 18px 24px;
    display: flex;
    .right-pcr-image {
      display: flex;
      justify-content: end;
    }
    .pcr-result,
    .pcr-date {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #c7c7c7;
      padding-bottom: 3px;
    }
    .pcr-result-subtitle,
    .pcr-date-subtitle {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #495057;
      word-break: break-word;
    }
    .pcr-result-subtitle {
      padding-bottom: 16px;
    }
  }
}
h4.vaccine-notes-header {
  margin-inline-start: 24px;
  margin-bottom: 10px;

  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #939393;
}
p.vaccine-notes-txt {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #495057;
  margin-inline-start: 24px;
  margin-bottom: 0px;
}
.columns-container {
  padding-top: 18px;
  padding-bottom: 16px;
}
p.vaccine-protocol {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  padding-top: 15px;
  padding-bottom: 3px;
  color: #c7c7c7;
}
p.vaccine-protocol-subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #495057;
}
.col-lg-4 {
  padding-inline-start: 0px;
}
.col-lg-6 {
  padding-inline-start: 0px;
}
.Vaccine-Name,
.Batch-Number,
.Vaccine-Expiry,
.Vaccine-Date {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #c7c7c7;
  padding-bottom: 3px;
  padding-inline-end: 20px;
}
.Vaccine-result,
.Batch-Number-result,
.Vaccine-Expiry-result,
.Vaccine-Date-result {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #495057;
  word-break: break-word;
  padding-inline-end: 20px;
}
.Vaccine-result,
.Batch-Number-result {
  padding-bottom: 16px;
}
.Batch-Number-result {
  padding-bottom: 16px;
}
</style>
